module.exports = __webpack_public_path__ + "static/media/wallet.25178c1e.svg";